var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.428571,
    y: 0.428571,
    width: 47.1429,
    height: 47.1429,
    rx: 23.5714,
    transform: "matrix(0 1 1 0 0 0)",
    stroke: "white",
    strokeWidth: 0.857143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 18V30",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 24L23.9995 30L29.9995 24",
    stroke: "white",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon);
export default __webpack_public_path__ + "static/media/circle-icon.600cd18a62c837987185e6931d419740.svg";
export { ForwardRef as ReactComponent };